<template>
  <div class="item_container" @click.stop="onItemClick">
    <div class="item_top">
      <div>{{ item.busiDesc }}</div>
      <div class="item_time">{{ item.acquireTimeStr }}</div>
    </div>
    <div class="creditVal_box">
      {{ item.creditVal }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {}
  },
  data() {
    return {}
  },
  filters: {
    // resetDate(str) {
    //   const restStr = new Date(str).toFormattedString('yyyy-MM-dd hh:mm:ss')
    //   return new Date(restStr.replace(/-/g, '/')).toFormattedString('yyyy-MM-dd')
    // }
  },

  methods: {
    onItemClick() {
      return
    }
  }
}
</script>

<style lang="less" scoped>
.item_container {
  padding: 0.4rem 0;
  border-bottom: 1px solid #f2f2f2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .creditVal_box {
    font-weight: bold;
    font-size: 0.4rem;
  }
  .add {
    color: #b03d3d;
  }
  .sub {
    color: #00b25a;
  }
  .item_time {
    font-size: 0.22rem;
    margin-top: 0.24rem;
    color: #999;
  }
}
</style>
